/** Field copy for a primary mobile number that fails the India rule (dnm-work#16). */
export const INDIAN_MOBILE_ERROR =
  'Enter a valid 10-digit Indian mobile number starting with 6, 7, 8 or 9 — for example 98765 43210.';

/**
 * Normalises typed or pasted phone text to 10 national digits (dnm-work#16 Contract):
 * strips spaces, dashes, brackets and dots, then a leading +91, 91 (only when 12
 * digits) or 0 (only when 11 digits). Anything that does not end up as exactly 10
 * digits is returned stripped but otherwise unchanged, so it fails validation
 * instead of being truncated into a different number.
 */
export function normalizeIndianPhoneEntry(raw: string): string {
  const stripped = raw.replace(/[\s\-().]/g, '');
  let national = stripped;
  if (national.startsWith('+91')) national = national.slice(3);
  else if (national.length === 12 && national.startsWith('91')) national = national.slice(2);
  else if (national.length === 11 && national.startsWith('0')) national = national.slice(1);
  return /^\d{10}$/.test(national) ? national : stripped;
}

/** India rule for a new primary number: 10 digits starting 6–9, or the 0000xxxxxx test range. */
export function isValidNewIndianMobile(national: string): boolean {
  return /^[6-9]\d{9}$/.test(national) || /^0000\d{6}$/.test(national);
}

/**
 * Parses and validates raw user input of recipient phone numbers.
 * Supports delimiters: newlines, commas, semicolons.
 * Normalizes entries with optional +91 or 0 prefix to 10 digits.
 */
export function parseAndValidateRecipientPhones(rawInput: string): {
  validPhones: string[];
  invalidEntries: string[];
} {
  const tokens = rawInput
    .split(/[\n,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);

  const validPhones: string[] = [];
  const invalidEntries: string[] = [];

  for (const token of tokens) {
    const digitsOnly = token.replace(/[\s-]/g, '');
    const match = digitsOnly.match(/^(?:\+91|0)?(\d{10})$/);
    if (match) {
      validPhones.push(match[1]);
    } else {
      invalidEntries.push(token);
    }
  }

  return { validPhones: Array.from(new Set(validPhones)), invalidEntries };
}
